import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { createHttpClient } from '@shared/adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { usePermissions } from '@shared/hooks/usePermissions';
import { OrdersApiAdapter } from '../adapters/OrdersApiAdapter';

const httpClient = createHttpClient(apiClientWH);
const adapter = new OrdersApiAdapter(httpClient);

export const useShipmentStatusCorrections = () => {
  const { orderId } = useParams<{ orderId: string }>();
  const { hasPermission } = usePermissions();
  const canView = hasPermission('orders.view');

  return useQuery({
    queryKey: ['shipmentStatusCorrections', orderId],
    queryFn: async () => {
      if (!orderId) return [];
      const response = await adapter.getShipmentStatusCorrections(Number(orderId));
      return response.data ?? [];
    },
    enabled: Boolean(orderId) && canView,
    staleTime: 2 * 60 * 1000,
    gcTime: 5 * 60 * 1000,
  });
};
